module.exports = __webpack_public_path__ + "img/image26.ef1ebcc6.png";